module.exports = __webpack_public_path__ + "static/media/sg-logo.e3019d5b.svg";